exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".items-builder .el-input-number--mini{max-width:95px}.items-builder .el-input-group__prepend{padding:0 8px}.items-builder .el-input-group--prepend{max-width:115px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1ebb1ae5","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/staff/blocks/ItemsBuilder.vue
// module id = 487
// module chunks = 0